import { useMutation } from "@tanstack/react-query";
import { addItemToCollection } from "directus/src/operations";
import { toast } from "sonner";
import { invalidateAllQueries } from "utils/utils";

export const useCreateBudgetAllocation = () => {
  return useMutation({
    mutationFn: async ({ values }) => {
      return await addItemToCollection("allocated_hours", values);
    },

    onSuccess: () => {
      invalidateAllQueries();
    },
    onError: (error) => {
      const message = error?.message || "Failed to create budget allocation";
      toast.error(message);
    },
  });
};
